import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@radix-ui/react-separator";
import { DashboardUser, DashboardSearch } from ".";
import { useSearchParams } from "react-router-dom";
export const DashboardHeader = () => {
  const [searchParams] = useSearchParams();

  const parent_id = searchParams.get("parent");

  return (
    <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
      <div className="flex items-center gap-2 px-4 justify-between w-full">
        {parent_id ? null : (
          <div className="flex md:min-w-[500px]">
            <SidebarTrigger className="-ml-1 md:hidden" />
            <DashboardSearch />
          </div>
        )}
        <div id="details-count" className=" flex-grow"></div>
        <span className="block md:hidden font-[600] text-[18px]">
          SimplyFlow
        </span>
        <Separator
          orientation="vertical"
          className="mr-2 h-4 hidden md:block"
        />
        <div>
          <DashboardUser />
        </div>
      </div>
    </header>
  );
};
